import type { ClusterOutlierPoint } from '@avisoma/shared';

// Concrete values required by recharts SVG fills; mapped to the Tailwind palette:
// emerald-500, amber-500, red-500.
const COLOR_MASS = '#10b981';
const COLOR_NEAR_THRESHOLD = '#f59e0b';
const COLOR_OUTLIER = '#ef4444';

export const THRESHOLD_LINE_COLOR = COLOR_NEAR_THRESHOLD;

export function clusterColor(point: ClusterOutlierPoint, threshold: number | null): string {
  if (threshold === null) {
    return COLOR_MASS;
  }
  if (point.isOutlier) {
    return COLOR_OUTLIER;
  }
  if (point.distance > threshold * 0.75) {
    return COLOR_NEAR_THRESHOLD;
  }
  return COLOR_MASS;
}
